// Page-local product fetching. Products aren't cross-cutting
// state (only Market reads them), so this deliberately does NOT
// live in the global store — keeps AppStore small and focused.

import { useEffect, useState } from 'react';
import { api } from '@/services/api';
import type { Product } from '@/types/product';

export interface UseProductsResult {
  products: Product[];
  loading: boolean;
  error: string | null;
}

export function useProducts(): UseProductsResult {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .getProducts()
      .then((data) => {
        if (cancelled) return;
        setProducts(data);
        setError(null);
      })
      .catch(() => {
        if (cancelled) return;
        setError('Could not load the marketplace right now.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { products, loading, error };
}
